import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Button } from './Button';
import { images } from '../data/content';
export function Hero() {
  const reduce = useReducedMotion();
  const ease = [0.23, 1, 0.32, 1] as const;
  return <section className="bg-white" data-id="element-203" data-mp="9ipc3be1pe04">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-6 pb-14 pt-8 sm:gap-14 sm:pb-20 sm:pt-14 lg:grid-cols-12 lg:gap-12 lg:px-10 lg:pb-24 lg:pt-20" data-id="element-204" data-mp="4m8msdv40tlg">
        <motion.div className="lg:col-span-7" initial={reduce ? false : {
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} data-id="element-205" data-mp="127ecf87a1fat">
          <div className="flex items-center gap-3 sm:gap-4" data-id="element-206" data-mp="nc89iu3h9wlp">
            <span className="h-px w-8 bg-gold sm:w-12" aria-hidden="true" data-id="element-207" data-mp="nbomx02vuk1c" />
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-ink/70 sm:text-xs sm:tracking-[0.22em]" data-id="element-208" data-mp="3d2l9xd9n5718">
              Executive Search &amp; Recruitment
            </p>
          </div>

          <h1 className="mt-5 font-serif text-[34px] font-medium leading-[1.08] tracking-tight text-navy sm:mt-8 sm:max-w-[14ch] sm:text-6xl sm:leading-[1.05] xl:text-[68px]" data-id="element-209" data-mp="3j9u1r1hjpsmv">
            Connecting Exceptional Talent With the <span className="italic" data-id="element-210" data-mp="399tckywzwiar">Right Opportunities.</span>
          </h1>

          <p className="mt-5 max-w-[34rem] text-[16px] leading-7 text-ink/75 sm:mt-8 sm:text-lg sm:leading-relaxed" data-id="element-211" data-mp="3e8ehvcr3ts62">
            We help organizations identify, engage, and connect with experienced professionals
            through focused{' '}
            <span className="font-medium text-navy" data-id="element-212" data-mp="35akn468zn6l0">executive search</span>,{' '}
            <span className="font-medium text-navy" data-id="element-213" data-mp="2qlofgaaufvkx">talent sourcing</span>, and{' '}
            <span className="font-medium text-navy" data-id="element-214" data-mp="2vjg6l23nzdo2">recruitment support</span>.
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:mt-10 sm:flex-row" data-id="element-215" data-mp="2hkggdq0i6qps">
            <Button to="/employers" className="w-full sm:w-auto" data-id="element-216" data-mp="2ll0f2y0q62e1">
              Hire Talent With Us
            </Button>
            <Button to="/candidates" variant="outline" className="w-full sm:w-auto" data-id="element-217" data-mp="s2tffr2zujsd">
              Explore Career Opportunities
            </Button>
          </div>
        </motion.div>

        <motion.div className="relative lg:col-span-5" initial={reduce ? false : {
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease
      }} data-id="element-218" data-mp="ibgjana5x7gj">
          <div className="absolute -bottom-4 -right-4 hidden h-full w-full border border-gold/70 sm:block" aria-hidden="true" data-id="element-219" data-mp="1b0ds7zshhrwm" />
          <img src={images.hero} alt="Senior leaders meeting around a boardroom table to discuss a leadership hire" className="relative aspect-[4/3] w-full object-cover object-[50%_40%] sm:aspect-[4/5] lg:object-center" data-id="element-220" data-mp="1126ncfbgz0az" />
        </motion.div>
      </div>
    </section>;
}